import Vue from 'vue'
import App from './App.vue'
import createRouter from './router'
import createStore from './store'
import VueMeta from 'vue-meta'

Vue.use(VueMeta)

// Create Vue app factory function (SSR requires new instance per request)
export default function createApp() {
  const router = createRouter()
  const store = createStore()
  const app = new Vue({
    router,
    store,
    render: (h) => h(App),
  })
  return {
    app,
    router,
    store,
  }
}
